import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { DocumentViewer } from '@/modules/documents/components/document-viewer/DocumentViewer';
import { useDocumentRequestFile } from '@/modules/document-requests/hooks/useDocumentRequestFile';

export const Route = createFileRoute(
  '/_authenticated/docs/document-request/$documentRequestId',
)({
  parseParams: z.object({
    documentRequestId: z.coerce.number(),
  }).parse,
  component: function DocumentRequestFile() {
    const { documentRequestId } = Route.useParams();

    const { objectUrl, contentType, filename, isLoading, error } =
      useDocumentRequestFile(documentRequestId);

    if (isLoading) {
      return (
        <div className="flex h-screen items-center justify-center">
          <p className="text-neutral-500">Carregando documento...</p>
        </div>
      );
    }

    if (error) {
      return (
        <div className="flex h-screen items-center justify-center">
          <p className="text-red-600">Erro ao carregar o documento</p>
        </div>
      );
    }

    if (!objectUrl) {
      return (
        <div className="flex h-screen items-center justify-center">
          <p className="text-neutral-500">Documento nao encontrado</p>
        </div>
      );
    }

    return (
      <div className="flex h-screen w-screen items-center justify-center bg-neutral-50">
        <DocumentViewer
          objectUrl={objectUrl}
          contentType={contentType}
          filename={filename}
          fullscreen
        />
      </div>
    );
  },
});
